module.exports = __webpack_public_path__ + "static/media/Boreal-Besties7.c0617f0f.jpg";